import { useState } from 'react';
import { useHistory } from 'react-router';
import { createExportXML } from '../../../../../api/custom/CompanySettingsAdvanced';
import { ADMIN_DELETE_COMPANY } from '../../../../../routes';
import Button from '../../../../components/Button';
import Link from '../../../../components/Link';
import LinkButton from '../../../../components/LinkButton';
import { getCurrentUser } from '../../../../services/CurrentUser';
import { isFeatureEnabled } from '../../../../services/Features';
import { interpolateAppUrl } from '../../../../services/Url';
import styles from '../style.m.less';

const MoreAdvancedSettings = () => {
    const allowXMLExports = isFeatureEnabled('FEATURE_xmlExports');
    const userIsAdmin = getCurrentUser().isAdmin;
    const history = useHistory();

    const [exportXMLIsOpen, setExportXMLIsOpen] = useState(false);

    const handleXMLExport = async () => {
        await createExportXML();
        history.push('/downloads');
    };

    return (
        <>
            <h2>Danger Zone</h2>
            <div>
                <LinkButton href={interpolateAppUrl(ADMIN_DELETE_COMPANY, {})} className={styles.deleteCompanyButton}>
                    Learn how to delete your company's content or your entire account
                </LinkButton>
            </div>

            <div className="hiddenOptionsContainer">
                {!allowXMLExports && (
                    <div>
                        <p>
                            This system has been configured to not allow XML Exports. Please contact
                            <Link href="mailto:support@small-improvements.com"> SI support</Link> to enable XML exports.
                        </p>
                    </div>
                )}

                {allowXMLExports && !userIsAdmin && (
                    <div>
                        <p>
                            This system has been configured to allow XML Exports, but you need the Tech Admin role to
                            use them.
                        </p>
                    </div>
                )}

                {allowXMLExports && userIsAdmin && (
                    <div>
                        <Button onClick={() => setExportXMLIsOpen(!exportXMLIsOpen)} className="showHiddenOptions">
                            Full export to XML
                        </Button>
                        {exportXMLIsOpen && (
                            <div className="boxGentleWarning">
                                <h3>Caution</h3>
                                <p>
                                    You are about to conduct a full export of your company database. This contains lots
                                    of confidential information. If your computer is not properly secured, then hackers
                                    can gain access to all your data.
                                    <b>Only proceed if this computer has been approved by your IT department.</b>
                                </p>
                                <p>
                                    Also, an entry will get written to the audit log, and your fellow admins will be
                                    able to see that you ran this export.
                                </p>
                                <p>
                                    Do you want to proceed? Your export file should appear in
                                    <Link href="/app/downloads">Your Latest Exports</Link> after a few minutes.
                                </p>
                                <Button onClick={handleXMLExport}>Proceed with system export to XML</Button>
                                <br />
                                <br />
                                <p>
                                    If you feel this export option should not be available at all with your company,
                                    please tell SI staff to disable this option in your account.
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default MoreAdvancedSettings;
